/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddEditClientRequestDto } from '../../models/add-edit-client-request-dto';
import { GeneralResponse } from '../../models/general-response';

export interface ClientAddNewClientPost$Params {
      body?: AddEditClientRequestDto
}

export function clientAddNewClientPost(http: HttpClient, rootUrl: string, params?: ClientAddNewClientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
  const rb = new RequestBuilder(rootUrl, clientAddNewClientPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralResponse>;
    })
  );
}

clientAddNewClientPost.PATH = '/Client/AddNewClient';
